import { InventoryLocationQuantities } from "../../inventory/data/model/inventoryData"
import { SupplierCost } from "../models"
import { InitialState } from "../reducer/types"

export const Selector = {
    
    get: (state): InitialState => {
        return state.product
    },

    isTackingInventory: (state): boolean => {
        return Selector.get(state).inventoryTracking
    },

    isNonInventory: (state): boolean => {
        return Selector.get(state).isNonInventory
    },

    getInventoryLocationQuantities: (state): InventoryLocationQuantities[] => {
        return Selector.get(state).inventoryLocationQuantities
    },

    getInventoryDataFromInventoryLocationQuantities: (locationQuantityID, state) => {
        return Selector.get(state).inventoryData.find((inventoryData) => {
            return inventoryData.attributes.inventoryLocationQuantities.id === locationQuantityID
        })
    },

    getSupplierCosts: (state): SupplierCost[] => {
        return Selector.get(state).supplierCosts as SupplierCost[]
    }
}


// WEBPACK FOOTER //
// ./src/state/product/selectors/selectors.ts